<template>
  <section class="m-1 mt-4 mb-4" v-if="show">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="title ml-3 pb-1">{{ city }}</h1>
      <!-- <span
        class="new-icons pointer btn-relatory btn-print"
        @click="redirectToRelatory"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.00002 9.00065V1.00065C2.00002 0.82384 2.07026 0.654271 2.19528 0.529246C2.32031 0.404222 2.48988 0.333984 2.66669 0.333984H13.3334C13.5102 0.333984 13.6797 0.404222 13.8048 0.529246C13.9298 0.654271 14 0.82384 14 1.00065V11.6673C14 12.1978 13.7893 12.7065 13.4142 13.0815C13.0392 13.4566 12.5305 13.6673 12 13.6673H2.66669C2.13625 13.6673 1.62755 13.4566 1.25247 13.0815C0.877401 12.7065 0.666687 12.1978 0.666687 11.6673V10.334H11.3334V11.6673C11.3334 11.8441 11.4036 12.0137 11.5286 12.1387C11.6536 12.2637 11.8232 12.334 12 12.334C12.1768 12.334 12.3464 12.2637 12.4714 12.1387C12.5964 12.0137 12.6667 11.8441 12.6667 11.6673V9.00065H2.00002Z"
            fill="white"
          />
        </svg>
      </span> -->
    </div>

    <CRow class="m-1">
      <CCol sm="12" class="d-flex align-items-center">
        <span
          @click="calendarModal = !calendarModal"
          class="new-icons pointer btn-relatory mr-3 mb-1"
          id="calendar-btn"
        >
          <svg
            width="14"
            height="14"
            viewBox="-1 1 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.333374 7.33268H13.6667V13.3327C13.6667 13.5095 13.5965 13.6791 13.4714 13.8041C13.3464 13.9291 13.1769 13.9993 13 13.9993H1.00004C0.82323 13.9993 0.65366 13.9291 0.528636 13.8041C0.403612 13.6791 0.333374 13.5095 0.333374 13.3327V7.33268ZM10.3334 1.99935H13C13.1769 1.99935 13.3464 2.06959 13.4714 2.19461C13.5965 2.31964 13.6667 2.4892 13.6667 2.66602V5.99935H0.333374V2.66602C0.333374 2.4892 0.403612 2.31964 0.528636 2.19461C0.65366 2.06959 0.82323 1.99935 1.00004 1.99935H3.66671V0.666016H5.00004V1.99935H9.00004V0.666016H10.3334V1.99935Z"
              fill="white"
            />
          </svg>
        </span>

        <Transition name="filter">
          <div class="absolute-box w-50" v-if="calendarModal" id="calendar">
            <v-date-picker v-model="range" is-range>
              <template v-slot:footer>
                <div class="d-flex justify-content-between mt-3">
                  <button
                    class="mb-3 w-100 ml-2 cancel-button"
                    @click="calendarModal = !calendarModal"
                  >
                    {{ $t("cancel") }}
                  </button>
                  <button
                    class="mb-3 mr-2 ml-2 w-100 send-button"
                    @click="sendDates"
                  >
                    {{ $t("filter") }}
                  </button>
                </div>
              </template>
            </v-date-picker>
          </div>
        </Transition>
        <DateLabel :name="lastDaysButtonLabel" class="no-pointer" />
      </CCol>
    </CRow>

    <div class="map-info">
      <div class="map-info-container">
        <div class="map-info-box map-width-reduced">
          <div class="map-info-counters">
            <div class="map-info-text">{{ $t("keepingSectors") }}</div>
            <div class="map-info-counter">
              {{ relatoryCity.keepingSectorCount }}
            </div>
          </div>
          <div>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.65 28.2285H20.2292C19.3916 28.2285 18.7125 28.9076 18.7125 29.7452C18.7125 30.5828 19.3916 31.2618 20.2292 31.2618H24.65C25.4877 31.2618 26.1667 30.5828 26.1667 29.7452C26.1667 28.9076 25.4877 28.2285 24.65 28.2285Z"
                fill="#5CCDF2"
              />
              <path
                d="M23.6666 21.5628C25.549 21.5628 27.075 20.0368 27.075 18.1544C27.075 16.2721 25.549 14.7461 23.6666 14.7461C21.7843 14.7461 20.2583 16.2721 20.2583 18.1544C20.2583 20.0368 21.7843 21.5628 23.6666 21.5628Z"
                fill="#5C7B9B"
              />
              <path
                d="M29.3667 18.7537C29.2286 17.7895 28.8962 16.8635 28.3897 16.0316C27.8831 15.1997 27.213 14.4793 26.4198 13.914C25.6266 13.3487 24.727 12.9504 23.7753 12.743C22.8236 12.5357 21.8398 12.5237 20.8834 12.7079C19.7136 12.9243 18.6167 13.4305 17.693 14.1802C16.7693 14.9299 16.0483 15.8992 15.5959 16.9995C15.1298 18.0916 14.9447 19.283 15.0575 20.4651C15.1704 21.6471 15.5775 22.782 16.2417 23.7662C17.1136 25.0352 18.0759 26.2397 19.1209 27.3703C19.4917 27.787 19.8709 28.1703 20.2709 28.5828C20.4459 28.7717 20.625 28.9592 20.8084 29.1453L20.8417 29.1828H18.1334C18.0678 29.186 18.0058 29.2141 17.9602 29.2613C17.9145 29.3085 17.8885 29.3713 17.8875 29.437C17.8853 29.5059 17.9102 29.573 17.957 29.6237C18.0038 29.6744 18.0687 29.7046 18.1375 29.7078H26.3375C26.4035 29.7015 26.4644 29.6696 26.5072 29.619C26.55 29.5684 26.5714 29.5031 26.5667 29.437C26.5679 29.3739 26.5448 29.3127 26.5021 29.2662C26.4595 29.2196 26.4005 29.1913 26.3375 29.187C26.2918 29.1827 26.2458 29.1827 26.2 29.187H25.1459C24.1931 29.187 23.2417 29.187 22.2917 29.187C22.0828 29.1891 21.8756 29.1492 21.6824 29.0697C21.4891 28.9903 21.3138 28.8729 21.1667 28.7245C19.5608 27.1742 18.0993 25.4812 16.8 23.6662C16.2593 22.9328 15.8799 22.0933 15.6867 21.2028C15.4936 20.3123 15.491 19.391 15.6792 18.4995C15.9481 17.0351 16.6995 15.7029 17.8135 14.7152C18.9276 13.7275 20.3402 13.1411 21.8263 13.0495C23.3123 12.958 24.7863 13.3665 26.0131 14.21C27.24 15.0535 28.1492 16.2834 28.5959 17.7037C28.9387 18.7066 29.0328 19.7777 28.8703 20.825C28.7077 21.8723 28.2932 22.8644 27.6625 23.7162C26.6072 25.1843 25.4502 26.5766 24.2 27.8828L24.1709 27.912C24.1264 27.9543 24.0872 28.0019 24.0542 28.0537C24.0227 28.1031 24.0089 28.1617 24.0151 28.2199C24.0213 28.2781 24.0471 28.3326 24.0883 28.3742C24.1294 28.4159 24.1835 28.4423 24.2417 28.4492C24.2999 28.456 24.3586 28.4429 24.4084 28.412C24.4549 28.3819 24.497 28.3454 24.5334 28.3037C25.8315 26.9608 27.0266 25.522 28.1084 23.9995C28.6557 23.2524 29.0489 22.4037 29.2649 21.5031C29.4809 20.6025 29.5155 19.6678 29.3667 18.7537Z"
                fill="black"
              />
              <path
                d="M22.3 24.1375H22.3208C22.4783 24.1353 22.6355 24.1242 22.7917 24.1042C23.5876 24.0037 24.3401 23.6843 24.9652 23.1815C25.5903 22.6786 26.0636 22.0121 26.3323 21.2562C26.6009 20.5002 26.6545 19.6846 26.4869 18.9C26.3194 18.1154 25.9374 17.3928 25.3833 16.8125C24.9753 16.3818 24.4845 16.0381 23.9404 15.8018C23.3962 15.5655 22.8099 15.4416 22.2167 15.4375L22 15.4583C21.8504 15.4647 21.7015 15.4814 21.5542 15.5083C20.7859 15.6134 20.0623 15.9307 19.4645 16.4247C18.8668 16.9186 18.4188 17.5695 18.1708 18.3042C17.879 19.0153 17.7934 19.7943 17.9238 20.5519C18.0543 21.3094 18.3955 22.0149 18.9083 22.5875C18.9314 22.6195 18.958 22.6488 18.9875 22.675C19.0338 22.7184 19.0949 22.7425 19.1583 22.7425C19.2218 22.7425 19.2829 22.7184 19.3292 22.675C19.3797 22.6383 19.4136 22.5831 19.4238 22.5215C19.4339 22.4599 19.4194 22.3968 19.3833 22.3458C19.3534 22.299 19.32 22.2544 19.2833 22.2125L19.2458 22.1667C18.7428 21.551 18.4507 20.79 18.4125 19.9958C18.3759 19.311 18.5246 18.629 18.8428 18.0215C19.1609 17.414 19.6369 16.9034 20.2207 16.5435C20.8045 16.1836 21.4744 15.9876 22.1601 15.9762C22.8458 15.9647 23.5219 16.1383 24.1173 16.4785C24.7128 16.8188 25.2055 17.3132 25.5438 17.9097C25.8821 18.5063 26.0534 19.183 26.0397 19.8686C26.0259 20.5543 25.8277 21.2236 25.4659 21.8061C25.104 22.3887 24.5919 22.863 23.9833 23.1792C23.4675 23.4452 22.897 23.5878 22.3167 23.5958C22.1042 23.5958 21.9833 23.6958 21.9833 23.8625C21.9812 23.8954 21.986 23.9283 21.9975 23.9592C22.009 23.9901 22.0269 24.0182 22.05 24.0417C22.1176 24.1051 22.2074 24.1395 22.3 24.1375Z"
                fill="black"
              />
              <path
                d="M19.7541 23.2494C20.1032 23.6022 20.543 23.8517 21.025 23.9702C21.0956 23.9838 21.1688 23.9691 21.2287 23.9294C21.2887 23.8897 21.3307 23.828 21.3458 23.7577C21.3595 23.6865 21.345 23.6128 21.3053 23.5522C21.2657 23.4915 21.204 23.4487 21.1333 23.4327C20.7623 23.3413 20.4235 23.1496 20.1541 22.8785C20.1289 22.8507 20.098 22.8285 20.0635 22.8134C20.029 22.7983 19.9918 22.7907 19.9541 22.791C19.9201 22.7909 19.8864 22.7974 19.855 22.8103C19.8235 22.8231 19.7949 22.8421 19.7708 22.866C19.7445 22.8901 19.7232 22.9191 19.7081 22.9514C19.693 22.9837 19.6844 23.0186 19.6829 23.0542C19.6813 23.0898 19.6868 23.1254 19.699 23.1589C19.7113 23.1924 19.73 23.2231 19.7541 23.2494Z"
                fill="black"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#C6C9D0"
              />
            </svg>
          </div>
        </div>
        <div class="map-info-box map-width-reduced">
          <div class="map-info-counters">
            <div class="map-info-text">{{ $t("executions") }}</div>
            <div class="map-info-counter">
              {{ relatoryCity.activitiesCount }}
            </div>
          </div>
          <div>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.1721 27.2768L16.9602 25.9685C16.6146 25.5954 16.032 25.5731 15.6589 25.9187L15.5366 26.032C15.1635 26.3776 15.1412 26.9602 15.4868 27.3333L16.6987 28.6416C17.0443 29.0147 17.627 29.0369 18 28.6913L18.1223 28.5781C18.4954 28.2325 18.5177 27.6499 18.1721 27.2768Z"
                fill="#5CCDF2"
              />
              <path
                d="M28.5625 24.5C30.461 24.5 32 22.961 32 21.0625C32 19.164 30.461 17.625 28.5625 17.625C26.664 17.625 25.125 19.164 25.125 21.0625C25.125 22.961 26.664 24.5 28.5625 24.5Z"
                fill="#5C7B9B"
              />
              <path
                d="M19.1667 30.7747C19.7723 30.8142 20.3802 30.8003 20.9833 30.7331L21.5833 30.6372H21.6167C24.8625 30.0122 27.375 28.1372 29.0875 25.1039C30.7542 22.1331 30.9292 18.7581 29.6 14.7872C29.5055 14.4353 29.3234 14.1132 29.0705 13.8508C28.8176 13.5885 28.5024 13.3946 28.1542 13.2872C27.7955 13.2129 27.4238 13.2308 27.074 13.3394C26.7242 13.448 26.4077 13.6437 26.1542 13.9081C25.3827 14.6728 24.3842 15.1669 23.3083 15.3164C22.1375 15.4581 20.95 15.5247 19.8042 15.5914H19.5667C18.2577 15.6002 16.9706 15.9277 15.8167 16.5456C12.6458 18.4331 10.75 22.5247 13.25 26.7039C13.311 26.8037 13.3639 26.9082 13.4083 27.0164L13.5292 27.3122L13.3542 27.5747C12.8996 28.2744 12.4823 28.9976 12.1042 29.7414C12.0899 29.7728 12.0825 29.8069 12.0825 29.8414C12.0825 29.8759 12.0899 29.91 12.1042 29.9414C12.1139 29.9741 12.1304 30.0044 12.1527 30.0302C12.175 30.0561 12.2024 30.0769 12.2333 30.0914C12.2637 30.1072 12.2968 30.1168 12.3309 30.1197C12.365 30.1226 12.3993 30.1187 12.4319 30.1083C12.4644 30.0978 12.4946 30.081 12.5206 30.0588C12.5466 30.0366 12.5679 30.0094 12.5833 29.9789C13.3231 28.51 14.232 27.1326 15.2917 25.8747L15.7083 25.3789L16.1667 25.8456C16.4 26.0831 16.6917 26.3872 16.9667 26.6789C17.0171 26.7308 17.086 26.7608 17.1583 26.7622C17.2251 26.763 17.2894 26.7376 17.3375 26.6914C17.3882 26.6435 17.4181 26.5777 17.4208 26.5081C17.4221 26.4737 17.4165 26.4394 17.4044 26.4072C17.3922 26.375 17.3737 26.3455 17.35 26.3206C16.9792 25.9247 16.7125 25.6456 16.5167 25.4414L16.1 24.9956L16.5542 24.5789C17.2312 23.9453 17.968 23.3788 18.7542 22.8872C19.7671 22.2234 20.8991 21.7621 22.0875 21.5289C22.1569 21.5195 22.2198 21.4833 22.2627 21.4279C22.3056 21.3726 22.325 21.3026 22.3167 21.2331C22.3126 21.199 22.3017 21.1661 22.2848 21.1363C22.2679 21.1065 22.2451 21.0804 22.218 21.0594C22.1908 21.0385 22.1598 21.0232 22.1267 21.0144C22.0935 21.0055 22.059 21.0034 22.025 21.0081C20.7731 21.2381 19.5801 21.717 18.5167 22.4164L17.575 22.9914V21.8872C17.575 21.6831 17.575 21.4706 17.575 21.2831C17.5755 21.2484 17.5691 21.214 17.5563 21.1818C17.5434 21.1496 17.5243 21.1203 17.5 21.0956C17.4519 21.0453 17.3862 21.0154 17.3167 21.0122C17.2478 21.0111 17.1812 21.0371 17.1313 21.0847C17.0814 21.1322 17.0522 21.1975 17.05 21.2664C17.0167 22.3081 17.0125 22.8247 17.05 23.1039V23.4122L16.8125 23.6081C15.9392 24.341 15.1408 25.1589 14.4292 26.0497L13.9042 26.7331L13.4667 25.9539C12.9868 25.0616 12.7218 24.0697 12.6929 23.057C12.664 22.0442 12.8719 21.0388 13.3 20.1206C13.6874 19.2052 14.2875 18.3954 15.0506 17.7584C15.8137 17.1215 16.7176 16.6757 17.6875 16.4581C18.6501 16.2803 19.6255 16.1813 20.6042 16.1622L21.3375 16.1289C23.1375 16.0247 25.0042 15.7456 26.45 14.3872C27.125 13.7539 27.7 13.7414 28.0375 13.8456C28.375 13.9497 28.8708 14.2622 29.0792 15.1497C29.4088 16.331 29.647 17.536 29.7917 18.7539C29.949 20.2076 29.7964 21.6782 29.344 23.0686C28.8915 24.4591 28.1494 25.7378 27.1667 26.8206C26.1745 27.8907 24.9686 28.7403 23.6271 29.3146C22.2855 29.8888 20.8383 30.1748 19.3792 30.1539H19.2875C19.2238 30.1531 19.1604 30.1629 19.1 30.1831C19.0705 30.1891 19.0422 30.2003 19.0167 30.2164C18.9786 30.2433 18.9474 30.2789 18.9257 30.3202C18.904 30.3614 18.8923 30.4073 18.8917 30.4539C18.8877 30.4932 18.8917 30.5329 18.9035 30.5706C18.9153 30.6083 18.9347 30.6433 18.9604 30.6733C18.9861 30.7033 19.0177 30.7277 19.0531 30.7452C19.0886 30.7626 19.1272 30.7727 19.1667 30.7747Z"
                fill="black"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#C6C9D0"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="map-info-container mt-3">
        <div class="map-info-box map-width-full">
          <div class="map-info-counters">
            <div class="map-info-text">{{ $t("photos") }}</div>
            <div class="map-info-counter">
              {{ relatoryCity.quantidade_foto }}
            </div>
          </div>
          <div>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5208 19.9297H14.0333C12.938 19.9297 12.05 20.8177 12.05 21.913V28.1297C12.05 29.2251 12.938 30.113 14.0333 30.113H14.5208C15.6162 30.113 16.5042 29.2251 16.5042 28.1297V21.913C16.5042 20.8177 15.6162 19.9297 14.5208 19.9297Z"
                fill="#5CCDF2"
              />
              <path
                d="M27.2208 23.696C28.9582 23.696 30.3667 22.2875 30.3667 20.5501C30.3667 18.8127 28.9582 17.4043 27.2208 17.4043C25.4834 17.4043 24.075 18.8127 24.075 20.5501C24.075 22.2875 25.4834 23.696 27.2208 23.696Z"
                fill="#5C7B9B"
              />
              <path
                d="M30.3584 29.7827H30.6125C30.8221 29.7731 31.0268 29.7165 31.2115 29.6169C31.3962 29.5174 31.556 29.3775 31.6792 29.2077C31.8666 28.9459 31.9619 28.6294 31.95 28.3077C31.95 26.4785 31.95 24.6243 31.95 22.8285V19.9452C31.95 19.1118 31.95 18.2785 31.95 17.4452C31.9558 17.1718 31.8795 16.903 31.731 16.6735C31.5824 16.444 31.3684 16.2643 31.1167 16.1577C30.896 16.0636 30.656 16.0236 30.4167 16.041H28.4375C28.2681 16.0604 28.0976 16.0161 27.959 15.9167C27.8204 15.8174 27.7236 15.6701 27.6875 15.5035L27.55 15.1118V15.0785L27.4167 14.7202C27.3491 14.4691 27.1969 14.2491 26.9858 14.0973C26.7748 13.9455 26.5179 13.8712 26.2584 13.8868H23.025C22.7682 13.8721 22.5142 13.9472 22.3067 14.0993C22.0991 14.2513 21.9509 14.4708 21.8875 14.7202C21.8375 14.8535 21.7917 14.9868 21.7459 15.1368L21.5834 15.5785C21.5475 15.6917 21.4789 15.7917 21.3862 15.8659C21.2935 15.94 21.1808 15.985 21.0625 15.9952C20.8641 16.0056 20.6652 16.0056 20.4667 15.9952H20.125V15.7035C20.125 15.5368 20.125 15.3827 20.125 15.2285C20.1253 15.0244 20.0472 14.8281 19.9069 14.68C19.7665 14.5319 19.5746 14.4433 19.3709 14.4327C18.625 14.4327 17.9 14.4327 17.0334 14.4327C16.926 14.4347 16.8204 14.4608 16.7245 14.5091C16.6286 14.5575 16.5447 14.6267 16.4792 14.7118C16.4561 14.7322 16.4377 14.7572 16.425 14.7852C16.4124 14.8132 16.4058 14.8436 16.4058 14.8743C16.4058 14.9051 16.4124 14.9354 16.425 14.9635C16.4377 14.9915 16.4561 15.0165 16.4792 15.0368C16.498 15.0588 16.5213 15.0765 16.5475 15.0886C16.5738 15.1007 16.6024 15.1069 16.6313 15.1069C16.6602 15.1069 16.6888 15.1007 16.715 15.0886C16.7413 15.0765 16.7646 15.0588 16.7834 15.0368C16.8535 14.9841 16.9336 14.9461 17.0188 14.9253C17.1041 14.9046 17.1927 14.9014 17.2792 14.916H19.1292C19.2097 14.9103 19.2904 14.9103 19.3709 14.916C19.4464 14.9235 19.5169 14.9572 19.5701 15.0112C19.6234 15.0652 19.6561 15.1362 19.6625 15.2118C19.6625 15.3827 19.6625 15.5535 19.6625 15.7327V16.0285H15.9584C15.8062 16.0225 15.6539 16.0337 15.5042 16.0618C15.1832 16.1294 14.8964 16.3081 14.6944 16.5666C14.4923 16.825 14.3881 17.1465 14.4 17.4743C14.4 19.5577 14.4 21.7243 14.4 23.7952V25.9827C14.3956 26.027 14.3956 26.0717 14.4 26.116C14.4091 26.1697 14.4373 26.2183 14.4794 26.2527C14.5216 26.2872 14.5748 26.3053 14.6292 26.3035C14.6834 26.3061 14.7365 26.2882 14.7782 26.2535C14.8198 26.2188 14.847 26.1697 14.8542 26.116C14.8584 26.0549 14.8584 25.9937 14.8542 25.9327V20.1327C14.8542 19.2535 14.8542 18.3452 14.8542 17.4493C14.8486 17.2149 14.931 16.9868 15.0853 16.8102C15.2396 16.6335 15.4545 16.5211 15.6875 16.4952C15.7791 16.4889 15.871 16.4889 15.9625 16.4952H20.9084C21.1593 16.5118 21.4084 16.4413 21.6134 16.2955C21.8184 16.1498 21.9667 15.9377 22.0334 15.6952C22.0834 15.5577 22.1292 15.416 22.1792 15.2785V15.2452C22.2209 15.1202 22.2625 14.9993 22.3084 14.8785C22.3405 14.7244 22.4285 14.5877 22.5554 14.4946C22.6824 14.4015 22.8392 14.3587 22.9959 14.3743H26.2834C26.4426 14.3524 26.6042 14.3906 26.7368 14.4816C26.8693 14.5725 26.9632 14.7096 27 14.866C27.0375 14.9785 27.0792 15.0868 27.1167 15.1993C27.1709 15.3618 27.2334 15.5452 27.3 15.7243C27.3581 15.9024 27.4617 16.0622 27.6006 16.1879C27.7394 16.3136 27.9087 16.4009 28.0917 16.441C28.2095 16.4655 28.3298 16.4753 28.45 16.4702H30.4917C30.6853 16.4554 30.8787 16.5023 31.044 16.6041C31.2094 16.7059 31.3384 16.8573 31.4125 17.0368C31.4753 17.1959 31.5064 17.3658 31.5042 17.5368C31.5042 20.2118 31.5042 22.9535 31.5042 25.391V27.416C31.5042 27.7118 31.5042 28.0493 31.5042 28.3827C31.5088 28.6249 31.4186 28.8594 31.2528 29.036C31.087 29.2127 30.8587 29.3177 30.6167 29.3285C30.5125 29.3285 30.4042 29.3285 30.3 29.3285H16.0875C15.9625 29.3285 15.8167 29.3285 15.6709 29.3285C15.5599 29.3179 15.4523 29.2851 15.3542 29.2322C15.2562 29.1792 15.1697 29.1071 15.1 29.0202C14.993 28.8943 14.9178 28.7446 14.8808 28.5836C14.8438 28.4226 14.8461 28.2551 14.8875 28.0952V28.041H15.75H16.7834C17.0681 28.0228 17.3351 27.896 17.5289 27.6866C17.7228 27.4772 17.8288 27.2013 17.825 26.916C17.825 25.7285 17.825 24.5118 17.825 23.4368V23.3243C17.825 22.5243 17.825 21.7285 17.825 20.9285C17.8312 20.7818 17.8078 20.6354 17.7563 20.4979C17.7047 20.3605 17.6261 20.2348 17.5251 20.1283C17.424 20.0218 17.3026 19.9367 17.168 19.878C17.0335 19.8194 16.8885 19.7884 16.7417 19.7868C16.575 19.7868 16.4 19.7868 16.2292 19.7868H16.1667C16.1156 19.7893 16.065 19.7991 16.0167 19.816C15.9729 19.8325 15.9359 19.8632 15.9117 19.9033C15.8875 19.9433 15.8776 19.9904 15.8834 20.0368C15.8833 20.0805 15.8981 20.1229 15.9254 20.157C15.9526 20.1911 15.9907 20.2148 16.0334 20.2243C16.1026 20.2429 16.1742 20.2513 16.2459 20.2493H16.7334C16.8918 20.2542 17.0428 20.3179 17.1568 20.4281C17.2709 20.5382 17.3397 20.6869 17.35 20.8452C17.3541 20.9048 17.3541 20.9647 17.35 21.0243V26.7035C17.348 26.7243 17.348 26.7452 17.35 26.766C17.3542 26.8326 17.3542 26.8994 17.35 26.966C17.3374 27.0941 17.2866 27.2154 17.2041 27.3143C17.1216 27.4131 17.0113 27.4848 16.8875 27.5202C16.7925 27.5456 16.6942 27.5568 16.5959 27.5535H14.7334C14.475 27.5535 14.4 27.6285 14.4 27.8952V28.0077C14.4 28.1368 14.4 28.2702 14.4 28.4035C14.4063 28.6694 14.4879 28.928 14.6355 29.1493C14.783 29.3706 14.9903 29.5454 15.2334 29.6535C15.4714 29.7487 15.7275 29.79 15.9834 29.7743H30.3584V29.7827Z"
                fill="black"
              />
              <path
                d="M21.8041 18.0916C20.7592 18.6402 19.9287 19.5237 19.4455 20.6004C18.9623 21.6771 18.8545 22.8848 19.1393 24.0301C19.424 25.1754 20.0849 26.192 21.0161 26.9171C21.9473 27.6422 23.0948 28.0337 24.275 28.0291C25.1785 28.0302 26.067 27.7977 26.8541 27.3541C27.818 26.8115 28.5869 25.9797 29.0521 24.9762C29.5174 23.9728 29.6554 22.8485 29.4467 21.7623C29.2381 20.6761 28.6932 19.6829 27.8893 18.9233C27.0853 18.1637 26.0629 17.6759 24.9666 17.5291C24.7305 17.4983 24.4923 17.4858 24.2541 17.4916C24.2234 17.4904 24.1927 17.4957 24.1641 17.507C24.1354 17.5184 24.1095 17.5356 24.0879 17.5576C24.0663 17.5795 24.0496 17.6058 24.0387 17.6346C24.0279 17.6634 24.0232 17.6942 24.025 17.725C24.0227 17.7556 24.0265 17.7864 24.0362 17.8156C24.0459 17.8448 24.0612 17.8718 24.0814 17.895C24.1015 17.9182 24.126 17.9373 24.1535 17.951C24.181 17.9647 24.211 17.9729 24.2416 17.975C24.2818 17.9792 24.3223 17.9792 24.3625 17.975H24.3916C25.0934 17.9918 25.7824 18.1655 26.4083 18.4833C27.3709 18.9648 28.1424 19.7577 28.5974 20.7332C29.0524 21.7086 29.1642 22.8092 28.9146 23.8562C28.6651 24.9032 28.0688 25.835 27.2227 26.5003C26.3767 27.1656 25.3305 27.5252 24.2541 27.5208C24.0579 27.5226 23.8617 27.5129 23.6666 27.4916C22.5084 27.3447 21.4443 26.7778 20.6763 25.8984C19.9082 25.019 19.4897 23.8883 19.5 22.7208C19.4998 21.8608 19.736 21.0173 20.1828 20.2825C20.6296 19.5477 21.2697 18.9498 22.0333 18.5541L22.1125 18.5125C22.1602 18.4895 22.2062 18.463 22.25 18.4333C22.3002 18.4029 22.3368 18.3544 22.3523 18.2978C22.3678 18.2412 22.361 18.1809 22.3333 18.1291C22.3138 18.0882 22.2831 18.0536 22.2447 18.0292C22.2064 18.0049 22.162 17.9919 22.1166 17.9916H22.0416C21.972 18.0152 21.905 18.0459 21.8416 18.0833L21.8041 18.0916Z"
                fill="black"
              />
              <path
                d="M27.8334 22.7133C27.8308 22.5445 27.8169 22.376 27.7917 22.2091C27.7223 21.74 27.5583 21.2898 27.3098 20.8858C27.0613 20.4819 26.7333 20.1326 26.3459 19.8591C25.7395 19.42 25.0112 19.1811 24.2625 19.1758C24.0629 19.1757 23.8635 19.1924 23.6667 19.2258C22.8285 19.3784 22.0707 19.821 21.526 20.4761C20.9813 21.1313 20.6845 21.9571 20.6875 22.8091C20.6995 23.7457 21.0786 24.6402 21.7433 25.3002C22.4079 25.9601 23.305 26.3329 24.2417 26.3383H24.2667C25.1167 26.3343 25.9377 26.0287 26.5834 25.4758C26.8855 25.2294 27.1385 24.9283 27.3292 24.5883C27.3476 24.5615 27.3601 24.5311 27.3659 24.4992C27.3717 24.4672 27.3706 24.4343 27.3627 24.4028C27.3548 24.3713 27.3403 24.3418 27.3202 24.3163C27.3 24.2908 27.2747 24.2699 27.2459 24.2549C27.1923 24.2227 27.1284 24.212 27.0672 24.2252C27.0061 24.2383 26.9522 24.2743 26.9167 24.3258C26.8917 24.3591 26.8709 24.3924 26.85 24.4258C26.8362 24.4503 26.8209 24.474 26.8042 24.4966C26.407 25.075 25.825 25.501 25.1537 25.7048C24.4823 25.9087 23.7617 25.8781 23.11 25.6181C22.4584 25.3582 21.9145 24.8843 21.5678 24.2744C21.2211 23.6644 21.0921 22.9547 21.2021 22.2618C21.3121 21.5689 21.6545 20.934 22.173 20.4614C22.6916 19.9889 23.3554 19.7067 24.0555 19.6613C24.7557 19.6159 25.4504 19.81 26.0256 20.2117C26.6008 20.6133 27.0223 21.1987 27.2209 21.8716C27.2738 22.0767 27.31 22.2857 27.3292 22.4966C27.3292 22.5758 27.3292 22.6549 27.3584 22.7341C27.3834 22.9091 27.4834 23.0133 27.6167 23.0049C27.6502 23.0004 27.6825 22.9891 27.7116 22.9719C27.7408 22.9547 27.7662 22.9318 27.7864 22.9047C27.8065 22.8775 27.8211 22.8466 27.8292 22.8137C27.8372 22.7809 27.8387 22.7467 27.8334 22.7133Z"
                fill="black"
              />
              <path
                d="M25.7833 15.5044C25.7333 15.5044 23.5583 15.5044 23.5083 15.5044C23.4512 15.5107 23.3986 15.5381 23.3608 15.5813C23.323 15.6245 23.3028 15.6804 23.3042 15.7378C23.3027 15.7956 23.3227 15.852 23.3605 15.8959C23.3982 15.9397 23.4509 15.968 23.5083 15.9753C23.55 15.9753 25.7042 15.9753 25.7792 15.9753C25.8373 15.9676 25.8906 15.939 25.9292 15.895C25.9679 15.8509 25.9892 15.7943 25.9892 15.7357C25.9892 15.6771 25.9679 15.6205 25.9292 15.5764C25.8906 15.5323 25.8373 15.5038 25.7792 15.4961L25.7833 15.5044Z"
                fill="black"
              />
              <path
                d="M30.1375 27.6129H28.9875C28.9322 27.6056 28.8762 27.6056 28.8208 27.6129C28.7744 27.6275 28.7341 27.6571 28.7062 27.697C28.6783 27.737 28.6644 27.785 28.6667 27.8337C28.6615 27.8838 28.673 27.9342 28.6993 27.9772C28.7257 28.0201 28.7655 28.0531 28.8125 28.0712C28.8719 28.0892 28.9338 28.0976 28.9958 28.0962H30.125C30.2386 28.1025 30.3507 28.0686 30.4417 28.0004C30.479 27.9563 30.4984 27.8997 30.4958 27.842C30.4917 27.6962 30.3708 27.6129 30.1375 27.6129Z"
                fill="black"
              />
              <path
                d="M29.3792 26.3757C29.3769 26.4058 29.3806 26.436 29.3901 26.4647C29.3995 26.4934 29.4146 26.5199 29.4343 26.5427C29.4541 26.5656 29.4781 26.5843 29.5052 26.5978C29.5322 26.6113 29.5616 26.6194 29.5917 26.6215C29.8207 26.634 30.0502 26.634 30.2792 26.6215C30.3367 26.6174 30.3907 26.5921 30.4307 26.5506C30.4707 26.509 30.4939 26.4541 30.4959 26.3965C30.4982 26.3344 30.4766 26.2738 30.4355 26.2273C30.3944 26.1807 30.3369 26.1518 30.275 26.1465H29.5959C29.5383 26.1524 29.4848 26.1788 29.445 26.2209C29.4052 26.2629 29.3819 26.3178 29.3792 26.3757Z"
                fill="black"
              />
              <path
                d="M17.4709 17.416C17.277 17.416 17.0875 17.4736 16.9264 17.5813C16.7653 17.6891 16.6398 17.8423 16.5658 18.0214C16.4918 18.2006 16.4727 18.3977 16.5108 18.5878C16.5489 18.7778 16.6426 18.9523 16.78 19.089C16.9173 19.2258 17.0922 19.3187 17.2824 19.356C17.4726 19.3934 17.6696 19.3734 17.8485 19.2986C18.0273 19.2239 18.1799 19.0977 18.287 18.9362C18.3941 18.7746 18.4508 18.5849 18.45 18.391C18.45 18.2626 18.4247 18.1355 18.3754 18.0169C18.3262 17.8984 18.254 17.7907 18.163 17.7001C18.072 17.6095 17.964 17.5378 17.8453 17.489C17.7265 17.4403 17.5992 17.4155 17.4709 17.416ZM18.0459 18.391C18.0467 18.5049 18.0137 18.6165 17.951 18.7116C17.8883 18.8067 17.7988 18.8811 17.6938 18.9252C17.5888 18.9694 17.4731 18.9814 17.3613 18.9596C17.2494 18.9379 17.1466 18.8835 17.0658 18.8033C16.9849 18.723 16.9298 18.6206 16.9072 18.5089C16.8847 18.3973 16.8958 18.2814 16.9392 18.1761C16.9826 18.0708 17.0563 17.9808 17.151 17.9174C17.2456 17.854 17.357 17.8202 17.4709 17.8202C17.6205 17.8201 17.7643 17.8784 17.8717 17.9827C17.979 18.0869 18.0415 18.2289 18.0459 18.3785V18.391Z"
                fill="black"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#C6C9D0"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-map">
      <div>
        <p class="activities-counter">
          {{ $t("showing") }} {{ relatoryCity.activitiesCount }}
          {{
            relatoryCity.activitiesCount === 1
              ? $t("oneExecution")
              : $t("moreExecutions")
          }}
        </p>
      </div>

      <div class="switch-style">
        <CustomSwitch
          :disabled="relatoryCity.activitiesCount === 0"
          @checkedSync="checkAllData"
          :selected="checkAll"
        />

        <p class="switch-label">
          {{ $t("activate").toUpperCase() }} <br />
          {{ $t("all").toUpperCase() }}
        </p>
      </div>
    </div>

    <div class="activities-container">
      <ActivitiesList
        :checkAll="checkAll"
        @filter-by-tag="filterTag"
        :activitiesData="relatoryCity.activities"
        @desactivate-pins="desactivatePins"
        @request-activity-data="requestActivityData"
      />
    </div>
  </section>
</template>

<script>
import { dateToText } from "../../utils/date";
import ActivitiesList from "../../components/ActivitiesList.vue";
import DateLabel from "../../components/DateLabel.vue";
import CustomSwitch from "../CustomSwitch.vue";

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    dates: {
      type: Array,
      required: true,
    },
    relatoryCity: {
      type: Object,
      required: true,
    },
    lastDaysButtonLabel: {
      type: String,
      required: true,
    },
    checkAllCity: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ActivitiesList,
    DateLabel,
    CustomSwitch,
  },
  data() {
    return {
      dateToText,
      filterModal: false,
      calendarModal: false,
      checkAll: this.checkAllCity,
      range: {
        start: null,
        end: null,
      },
      city: "",
    };
  },
  watch: {
    dates(newValue) {
      this.range = {
        start: newValue[0],
        end: newValue[1],
      };
    },
  },
  mounted: async function () {
    if (this.dates) {
      this.range = {
        start: this.dates[0],
        end: this.dates[1],
      };
    } else {
      this.range = {
        start: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).toISOString(),
        end: new Date().toISOString(),
      };
    }
    this.$store.dispatch("global/setUser").then(() => {
      const user = this.$store.state.global.user;
      this.city = user.usuario_cidade.slice(0, -3);
    });

    document.addEventListener("click", (e) => {
      if (
        !e.target.closest("#calendar") &&
        !e.target.closest("#calendar-btn")
      ) {
        this.calendarModal = false;
      }
    });
  },
  methods: {
    sendDates() {
      // checa se data está em format UTC para transformat em ISO
      let end = this.range.end.toString();
      let start = this.range.start.toString();

      if (start.includes("GMT") && end.includes("GMT")) {
        start = this.range.start.toISOString().slice(0, -5);
        end = this.range.end.toISOString().slice(0, -5);
      } else {
        start = this.range.start;
        end = this.range.end;
      }

      this.$emit("filter-by-date", {
        start,
        end,
      });
      this.calendarModal = false;
    },

    blockChooseDaysFromDifferentMonths() {
      this.range = {
        start: null,
        end: null,
      };
    },
    requestActivityData(id) {
      this.$emit("request-activity-data", id);
    },
    desactivatePins(id) {
      this.$emit("desactivate-pins", id);
    },
    filterTag(tags, activityId) {
      this.$emit("filter-by-tag", tags, activityId);
    },
    checkAllData(selected) {
      this.checkAll = selected;
    },
    redirectToRelatory() {
      this.$store.dispatch("global/setPrintNeighborhood", {
        dates: this.dates,
        relatoryCity: this.relatoryCity,
      });
      this.$router.push({
        name: "Measurement",
        params: {
          range: this.range,
          type: "city",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  color: #29334e;
}

.map-info {
  width: 100%;
  margin-left: 16px;
  padding-right: 18px;
  margin-top: 32px;

  .map-info-container {
    display: flex;
    gap: 8px;

    .map-width-reduced {
      width: 50%;
      margin-right: 8px;
    }

    .map-width-full {
      width: 100%;
      margin-right: 8px;
    }

    .map-info-box {
      border: 1px solid #c6c9d0;
      border-radius: 16px;
      padding: 21px 24px 21px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.map-info-counters {
  .map-info-text {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.014em;
    color: #565e73;
  }

  .map-info-counter {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #29334e;
  }
}

.filter-map {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 12px;

  .switch-style {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  .switch-label {
    font-family: "OpenSans-Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 156%;
    text-align: center;
    color: #838998;
    padding-top: 8px;
    margin-left: 8px;
  }
}

.activities-counter {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: #838998;
}

.absolute-box {
  position: absolute;
  z-index: 10;
  top: 12px;
  left: 30px;
}

.send-button {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 8px 24px;
  background: #003063;
  border-radius: 8px;
  margin: 0px 8px;
  outline: none;
  border: none;

  &:hover {
    background: #002a5a;
  }

  &:active {
    background: #002a5a;
  }
}

.cancel-button {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #565e73;
  margin: 0px 8px;
  padding: 8px 24px;
  background: #ffffff;
  border: 1px solid #dddee3;
  border-radius: 8px;

  &:hover {
    background: #f5f5f5;
  }

  &:active {
    background: #e5e5e5;
  }
}

.separator-calendar {
  border: 1px solid #ececec;
  width: 85%;
  margin-top: 0;
}

.btn-relatory {
  width: 32px;
  height: 32px;
}

.btn-print {
  margin-right: 10px;
  margin-bottom: 12px;
}

.activities-container {
  margin-left: 16px;
  margin-right: 12px;
  margin-top: 16px;
}

.filter-enter-active {
  animation: filter-in 0.3s;
}
.filter-leave-active {
  animation: filter-in 0.3s reverse;
}
@keyframes filter-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}
</style>
